import Vue from "vue";
import axios from "axios";
import Vuex from "vuex";
import i18n from "@/plugins/i18n";

Vue.use(Vuex);
import { PURGE_AUTH, SET_LOADING } from "@/store/mutations.type";
import { ALERT } from "@/common/utilities";
import JwtService from "@/common/jwt.service.js";
import { SCREEN } from "@/common/auth.const";

const customAxios = axios.create({
  baseURL: `${window.location.protocol}//${window.location.hostname}:${process.env.VUE_APP_API_PORT}/sinop`,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${JwtService.getToken()}`,
  },
});
customAxios.interceptors.response.use(
  (response) => {
    /*vm.$store.commit(SET_LOADING, [false, true]);*/
    return response;
  },
  (err) => {
    vm.$store.commit(SET_LOADING, [false, true]);
    handlerException(err);
  },
);
customAxios.interceptors.request.use((config) => {
  /*if (config.setLoading) vm.$store.commit(SET_LOADING, [true, true]);*/
  config.headers = {
    ...config.headers,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${JwtService.getToken()}`,
  };
  return config;
});

export default {
  query(resource, params, setLoading = true) {
    return customAxios.get(resource, {
      params,
      setLoading,
    });
  },

  get(resource, slug = "", setLoading = true) {
    let url = resource;
    if (slug) url = url + `/${slug}`;
    return customAxios.get(url, {
      setLoading,
    });
  },

  post(resource, params, setLoading = true) {
    return customAxios.post(`${resource}`, params, {
      setLoading,
    });
  },

  update(resource, slug, params, setLoading = true) {
    return customAxios.put(`${resource}/${slug}`, params, { setLoading });
  },

  put(resource, params, setLoading = true) {
    return customAxios.put(`${resource}`, params, {
      setLoading,
    });
  },

  delete(resource, setLoading = true) {
    return customAxios.delete(resource, {
      setLoading,
    });
  },

  getUsingConfig(resource, slug = "", config = {}, setLoading = true) {
    let url = `${resource}`;
    if (slug) {
      url = `${url}/${slug}`;
    }
    return customAxios.get(`${url}`, {
      ...config,
      setLoading,
    });
  },

  postUsingConfig(resource, params, config = {}, setLoading = true) {
    return customAxios.post(`${resource}`, params, {
      ...config,
      setLoading,
    });
  },
};

function handlerException(error) {
  if (!error.response) {
    const msg = vm.$store.getters.isOnline
      ? i18n.t("msg.errorSystem")
      : i18n.t("msg.noInternet");
    ALERT.ERROR(msg, 10000);
    throw error;
  }

  if (error.response.status === 401) {
    ALERT.ERROR(i18n.t("msg.sessionExpired"));
    vm.$store.commit(PURGE_AUTH);
    /*vm.$router.push("/login");*/
    vm.$store.commit(SET_LOADING, [true, true]);
    setTimeout(() => {
      window.location = SCREEN.LOGIN.PATH;
      vm.$store.commit(SET_LOADING, [false, true]);
    }, 300);
  }

  if ([403, 409].includes(error.response.status)) {
    vm.$router.push({
      name: SCREEN.ERR403.NAME,
    });
  }

  if (error.response.status === 404) {
    ALERT.ERROR(i18n.t("msg.objectNotFound"));
    vm.$router.push({
      name: SCREEN.HOME.NAME,
    });
  }

  const array = error.response.data.internal.split("/");
  const excepted = ["login", "change-password", "import"];
  if (
    [400, 422, 500].includes(error.response.status) &&
    !excepted.includes(array[array.length - 1])
  ) {
    const errorMessage =
      error.response.data.title === i18n.t("msg.errorSystem")
        ? i18n.t("msg.errorSystem")
        : error.response.data.title;
    ALERT.ERROR(errorMessage);
  }

  throw error;
}
